import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { PiShareNetworkLight } from "react-icons/pi";
import FavoriteButton from "../../Favourite_button/favourite_button";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import ShareModal from "../../share_alert/sharealert";
import Lightbox from "yet-another-react-lightbox";
import Badge from "@mui/material/Badge";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import "yet-another-react-lightbox/styles.css";
import "./Product.css";

const Product = ({ product }) => {
  // Product images Gallery
  const [open, setOpen] = useState(false);
  const productImg = product.images || [];
  const [currentImg, setCurrentImg] = useState(0);

  // Share Pop up settings
  const [isModalOpen, setIsModalOpen] = useState(false);
  const productUrl = `https://www.eadaad.com/product/${product.productId}`;

  const prevImg = () => {
    setCurrentImg(currentImg === 0 ? productImg.length - 1 : currentImg - 1);
  };

  const nextImg = () => {
    setCurrentImg(currentImg === productImg.length - 1 ? 0 : currentImg + 1);
  };

  // Product Quantity

  const [quantity, setQuantity] = useState(1);

  const increment = () => {
    setQuantity(quantity + 1);
  };

  const decrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleInputChange = (event) => {
    const value = parseInt(event.target.value);
    if (!isNaN(value) && value > 0) {
      setQuantity(value);
    }
  };

  // Product WishList

  const [clicked, setClicked] = useState(false);

  const handleWishClick = () => {
    setClicked(!clicked);
  };

  const [selectSize, setSelectSize] = useState("S");

  // Available Sizes and Colors
  const availableSizes = product.hasSize ? product.variants.map(variant => variant.size) : [];
  const availableColors = product.hasColor ? product.variants.map(variant => variant.color) : [];
  // Product Colors

  const [highlightedColor, setHighlightedColor] = useState();

  // Product Detail to Redux

  const dispatch = useDispatch();

  const cartItems = useSelector((state) => state.cart.items);

  const handleAddToCart = () => {
    if (product.hasSize && !selectSize) {
      toast.error("Please select a size!", { duration: 2000 });
      return;
    }
    if (product.hasColor && !highlightedColor) {
      toast.error("Please select a color!", { duration: 2000 });
      return;
    }
    console.log(quantity);
    const productDetails = {
      productID: product.productId, // Ensure dynamic ID
      productName: product.title,
      productPrice: product.hasDiscount ? product.discountPrice : product.price,
      frontImg: productImg[0],
      quantity: quantity,
      ...(product.hasSize && { size: selectSize }),
      ...(product.hasColor && { color: highlightedColor }),
    };

    const productInCart = cartItems.find(
      (item) =>
        item.productID === productDetails.productID &&
        (item.size === productDetails.size || !productDetails.size) &&
        (item.color === productDetails.color || !productDetails.color)
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(productDetails));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };
  const handleImageClick = () => {
    console.log("Image clicked");
    setOpen((prev) => !prev);
    console.log("Lightbox open state:", !open);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const isProductInCart = cartItems.some(
    (item) =>
      item.productID === product.productId &&
      (item.size === selectSize || !product.hasSize) &&
      (item.color === highlightedColor || !product.hasColor)
  );
  return (
    <>
      <div className="productSection">
        <div className="productShowCase">
          <div className="productGallery">
            <div className="productThumb">
              {productImg.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  onClick={() => setCurrentImg(index)}
                  alt={`Thumbnail ${index + 1}`}
                />
              ))}
            </div>
            <div className="productFullImg">
              <img src={productImg[currentImg]} alt="" onClick={handleImageClick} className="cursor-pointer" />
              <div className="buttonsGroup">
                <button onClick={prevImg} className="directionBtn">
                  <GoChevronLeft size={18} />
                </button>
                <button onClick={nextImg} className="directionBtn">
                  <GoChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>
          <div className="productDetails">
            <div className="productBreadcrumb">
              <div className="breadcrumbLink">
                <Link to="/">Home</Link>&nbsp;/&nbsp;
                <Link to="/shop">The Shop</Link>
              </div>
              {/* <div className="prevNextLink">
                <Link to="/product">
                  <GoChevronLeft />
                  <p>Prev</p>
                </Link>
                <Link to="/product">
                  <p>Next</p>
                  <GoChevronRight />
                </Link>
              </div> */}
            </div>
            <div className="productName">
              <h1>{product.title}</h1>
            </div>
            <div className="productRating" >
              {Array.from({ length: 5 }).map((_, index) => {
                const rating = product.totalRating / product.totalPeopleReview; // Calculate average rating
                const fullStars = Math.floor(rating);
                const hasHalfStar = rating - fullStars >= 0.5;
                if (index < fullStars) {
                  return <FaStar key={index} color="#FEC78A" size={14} />;
                } else if (index === fullStars && hasHalfStar) {
                  return <FaStarHalfAlt key={index} color="#FEC78A" size={14} />;
                } else {
                  return <FaRegStar key={index} color="#FEC78A" size={14} />;
                }
              })}
              <p>{product.totalPeopleReview} reviews</p>
            </div>
            <div className="productPrice">
              <h3>
                {product.hasDiscount ? (
                  <>
                    <span style={{ textDecoration: "line-through", color: "gray", marginRight: "5px" }}>
                      Rs.{product.price}
                    </span>
                    <span style={{ color: "black", }}>Rs.{product.discountPrice}</span>
                  </>
                ) : (
                  <span>Rs.{product.price}</span>
                )}
              </h3>
            </div>
            <div className="productDescription">
              <p>
                {product.description}
              </p>
            </div>
            <div className="productSizeColor">
              {/* {product.hasSize && ( 
                <div className="productSize">
                  <p>Sizes</p>
                  <div className="sizeBtn">
                    {availableSizes.map((size, index) => (
                      <Tooltip
                        key={size}
                        title={availableSizes[index]}
                        placement="top"
                        TransitionComponent={Zoom}
                        enterTouchDelay={0}
                        arrow
                      >
                        <button
                          style={{
                            borderColor: selectSize === size ? "#000" : "#e0e0e0",
                          }}
                          onClick={() => setSelectSize(size)}
                        >
                          {size}
                        </button>
                      </Tooltip>
                    
                    ))}
                  </div>
                </div>
              )} */}
              {product.hasSize && (
                <div className="productSize">
                  <p>Sizes</p>
                  <div className="sizeBtn">
                    {product.variants.map((variant, index) => {
                      const isOutOfStock = variant.stock === 0;
                      return (
                        <Tooltip
                          key={variant.size}
                          title={variant.size}
                          placement="top"
                          TransitionComponent={Zoom}
                          enterTouchDelay={0}
                          arrow
                        >
                          <button
                            style={{
                              borderColor: selectSize === variant.size ? "#000" : "#e0e0e0",
                              textDecoration: isOutOfStock ? "line-through" : "none",
                              color: isOutOfStock ? "#ccc" : "#000",
                              cursor: isOutOfStock ? "not-allowed" : "pointer",
                              opacity: isOutOfStock ? 0.5 : 1,
                            }}
                            disabled={isOutOfStock}
                            onClick={() => !isOutOfStock && setSelectSize(variant.size)}
                          >
                            {variant.size}
                          </button>
                        </Tooltip>
                      );
                    })}
                  </div>
                </div>
              )}


              {/* {product.hasColor && (
                <div className="productColor">
                  <p>Color</p>
                  <div className="colorBtn">
                    {availableColors.map((color, index) => (
                      <Tooltip
                        key={color}
                        title={availableColors[index]}
                        placement="top"
                        enterTouchDelay={0}
                        TransitionComponent={Zoom}
                        arrow
                      >
                        <button
                          className={
                            highlightedColor === color ? "highlighted" : ""
                          }
                          style={{
                            backgroundColor: color.toLowerCase(),
                            border:
                              highlightedColor === color
                                ? "0px solid #000"
                                : "0px solid white",
                            padding: "8px",
                            margin: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => setHighlightedColor(color)}
                        />
                      </Tooltip>
                     
                    ))}
                  </div>
                </div>
              )} */}
              {product.hasColor && (
                <div className="productColor">
                  <p>Color</p>
                  <div className="colorBtn">
                    {product.variants.map((variant, index) => {
                      const isOutOfStock = variant.stock === 0;
                      return (
                        <Tooltip
                          key={variant.color}
                          title={variant.color}
                          placement="top"
                          enterTouchDelay={0}
                          TransitionComponent={Zoom}
                          arrow
                        >
                          <button
                            className={highlightedColor === variant.color ? "highlighted" : ""}
                            style={{
                              backgroundColor: variant.color.toLowerCase(),
                              border: highlightedColor === variant.color ? "0px solid #000" : "0px solid white",
                              padding: "8px",
                              margin: "5px",
                              cursor: isOutOfStock ? "not-allowed" : "pointer",
                              opacity: isOutOfStock ? 0.5 : 1,
                            }}
                            disabled={isOutOfStock}
                            onClick={() => !isOutOfStock && setHighlightedColor(variant.color)}
                          />
                        </Tooltip>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <div className="productCartQuantity">
              <p>Quantity</p>
              <div className="productQuantity">
                <button onClick={decrement}>-</button>
                <input
                  type="text"
                  value={quantity}
                  onChange={handleInputChange}
                />
                <button onClick={increment}>+</button>
              </div>

            </div>
            <div className="productCartBtn">
              <button
                onClick={handleAddToCart}
                disabled={product.availableStock === 0}
                style={{cursor: product.availableStock === 0 ? 'not-allowed' : 'pointer' }}
              >
                {product.availableStock  === 0 ? 'Sold Out' : 'Add to Cart'}
              </button>
              {/* <button onClick={handleAddToCart}>Add to Cart</button> */}
            </div>

            {isProductInCart && (
              <div className="checkoutBtn">
                <Link to="/cart" className="checkoutLink" onClick={scrollToTop}>
                  <ShoppingCartIcon className="cartIcon" /> {/* Cart icon inside button */}
                  <span>Go to Cart</span>
                </Link>
              </div>
            )}
            <div className="productWishShare">
              <div className="productWishList">
                <button onClick={handleWishClick}>
                  <FavoriteButton productId={product.productId} />
                  <p>Add to Wishlist</p>
                </button>
              </div>
              <div className="productShare">
                <PiShareNetworkLight size={22} onClick={() => setIsModalOpen(true)} />
                <p>Share</p>
              </div>
            </div>
            <div className="productTags">
              <p>
                <span>SKU: </span>N/A
              </p>
              <p>
                <span>CATEGORIES: </span> {product.category}
              </p>
            </div>

          </div>
        </div>
        <ShareModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          productUrl={productUrl}
          productTitle={product.title}
        />
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={productImg.map((src) => ({ src }))} // Convert images to lightbox format
          index={currentImg} // Start from the selected image
        />
      </div>
    </>
  );
};

export default Product;
